import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Table from 'components/Table';
import { useTableColumns } from 'hooks/useTableColumns';
import { DocumentTables } from 'components/DocumentTables/DocumentTables';
import { Group, WfDefinitionEngineTask, Definition } from 'models/response';
import utils from 'utils';

const Container = styled.div`
  padding: 10px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  height: 100%;
  overflow: auto;
`;

const Title = styled.h3`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export interface WorkflowLogRow {
  dateAndTime?: number;
  sender: string;
  typology?: number;
  typeDescription?: string;
  rejectionReason?: string;
  logNotes?: string;
  causal?: string;
  wfDefinition?: Definition;
  recipient?: Group[];
}

interface WorkflowLogProps {
  protocol: number;
  rows: WorkflowLogRow[];
  tasks?: WfDefinitionEngineTask[];
}

const WorkflowLog: React.FC<WorkflowLogProps> = ({ rows, tasks = [] }) => {
  const t = utils.intl.useTranslator();
  const { tableColumns } = useTableColumns();
  const [selectedRow, setSelectedRow] = useState<WorkflowLogRow | null>(null);
  const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);

  const handleSelection = (item: WorkflowLogRow[]) => {
    setSelectedRow(item.length ? item[0] : null);
    if (!item.length) setSelectedGroup(null);
  };

  const handleGroupSelection = (item: Group[]) => {
    setSelectedGroup(item?.length ? item[0] : null);
  };

  return (
    <Container>
      <Title>{t('workflow-log')}</Title>
      <Table
        id="workflow-log-table"
        sortBy={[{ id: 'dateAndTime', desc: true }]}
        columns={tableColumns}
        rows={rows}
        hasPagination
        hasSort
        hasFilter
        hasSelection
        onSelection={handleSelection}
        hasToolbar={false}
        maxHeight={300}
      />

      <DocumentTables
        tasks={tasks}
        selectedDocument={selectedRow}
        selectedGroup={selectedGroup}
        onGroupSelection={handleGroupSelection}
        flexDirection="column"
      />
    </Container>
  );
};

export default WorkflowLog;
